/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../common";
import type {
  T721Logic,
  T721LogicInterface,
} from "../../../../../contracts/dependant/test/test721/T721Logic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Burn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "unlocker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Freeze",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "accessControl",
        type: "address",
      },
    ],
    name: "SetAccessControl",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "supportTransfer",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "supportMint",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "supportBurn",
        type: "bool",
      },
    ],
    name: "SetSupport",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "unlocker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Thaw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32[]",
        name: "attributeNames",
        type: "bytes32[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "changeRequester",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "uint256AttributeValues",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "bytes32[]",
        name: "bytes32AttributeValues",
        type: "bytes32[]",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "addressAttributeValues",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "bytesAttributeValues",
        type: "bytes[]",
      },
    ],
    name: "allAttribute",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burnNormal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burnSudo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenId",
        type: "uint256[]",
      },
    ],
    name: "burnSudos",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "unlocker",
        type: "address",
      },
    ],
    name: "freezeNormal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "unlocker",
        type: "address",
      },
    ],
    name: "freezeSudo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "frozen",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "unlock",
        type: "address",
      },
    ],
    name: "frozenDetail",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "attributeName",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getAddressAttribute",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "attributeName",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getAddressAttributes",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "attributeName",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getBytes32Attribute",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "attributeName",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getBytes32Attributes",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "attributeName",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getBytesAttribute",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "attributeName",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getBytesAttributes",
    outputs: [
      {
        internalType: "bytes[]",
        name: "",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTokenIdCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "attributeName",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getUint256Attribute",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "attributeName",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getUint256Attributes",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "interactAccountsContains",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interactAccountsLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "interactedAccountsAt",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listAttributeRegistries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "attributeName",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "attributeType",
            type: "uint256",
          },
        ],
        internalType: "struct HERC721IMType.AttributeRegistry[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mintNormal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mintSudo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenId",
        type: "uint256[]",
      },
    ],
    name: "mintSudos",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "accessControl_",
        type: "address",
      },
    ],
    name: "setAccessControl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "setAddressAttribute",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "attributeName",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "attributeType",
            type: "uint256",
          },
        ],
        internalType: "struct HERC721IMType.AttributeRegistry[]",
        name: "adds",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "attributeName",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "attributeType",
            type: "uint256",
          },
        ],
        internalType: "struct HERC721IMType.AttributeRegistry[]",
        name: "removes",
        type: "tuple[]",
      },
    ],
    name: "setAttributeRegistries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "bytes[]",
        name: "",
        type: "bytes[]",
      },
    ],
    name: "setAttributes",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockListFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockListTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "setBytes32Attribute",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "setBytesAttribute",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "from",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegeListFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegeListTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "supportTransfer_",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "supportMint_",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "supportBurn_",
        type: "bool",
      },
    ],
    name: "setSupport",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newTokenIdCounter",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "needSub1",
        type: "bool",
      },
    ],
    name: "setTokenIdCounter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "begin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "setTokenIdMapRange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "setUint256Attribute",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    name: "setUint256Attributes",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "support",
    outputs: [
      {
        internalType: "bool",
        name: "supportTransfer",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "supportMint",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "supportBurn",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "thawNormal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "unlocker",
        type: "address",
      },
    ],
    name: "thawSudo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenIdMapRange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "tokensOfOwner",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transferTxs",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type T721LogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: T721LogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class T721Logic__factory extends ContractFactory {
  constructor(...args: T721LogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<T721Logic> {
    return super.deploy(overrides || {}) as Promise<T721Logic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): T721Logic {
    return super.attach(address) as T721Logic;
  }
  override connect(signer: Signer): T721Logic__factory {
    return super.connect(signer) as T721Logic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): T721LogicInterface {
    return new utils.Interface(_abi) as T721LogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): T721Logic {
    return new Contract(address, _abi, signerOrProvider) as T721Logic;
  }
}
